const functionTest = v => {
    return ( v instanceof Function );
};

export default functionTest;